module.exports = __webpack_public_path__ + "static/14four-logo-c44baa2d5f8e9a5f2b0427e6f524a7c6.webp";